"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compute_auto_unitary_sankey = void 0;
const d3 = __importStar(require("d3"));
// OpenSankey imports
const FunctionOSTyped_1 = require("./FunctionOSTyped");
const SankeyDrawLayout_1 = require("open-sankey/dist/draw/SankeyDrawLayout");
/**
 * Calcul la plus longue branch
 * Determination de la position horiz
 * Determination de la position vericale
 * Post-traitement ecart
 *
 * @param {SankeyDevData} data Data structure for Sankey
 * @param {number} h_space Horizontal spacing factor
 */
const compute_auto_unitary_sankey = (data, ref_setter_contextualised_node, h_space) => {
    // Get list of currently displayed nodes
    const display_nodes = Object.keys(data.nodes)
        .filter((key) => (0, FunctionOSTyped_1.NodeDisplayed)(data, data.nodes[key]))
        .reduce((obj, key) => {
        return Object.assign(obj, {
            [key]: data.nodes[key]
        });
    }, {});
    // Compute value of contextualised node
    // Only get value of link displayed at the time of the compute_auto_unitary_sankey so we adjust the scale to make the unitary node at a height of 200px
    let output_link_sum = 0;
    ref_setter_contextualised_node.outputLinksId.filter(lid => (0, FunctionOSTyped_1.NodeDisplayed)(data, data.nodes[data.links[lid].idTarget]))
        .forEach((idLink) => {
        const tmp = (0, FunctionOSTyped_1.GetLinkValue)(data, idLink).value;
        output_link_sum += tmp !== '' ? tmp : 0;
    });
    let input_link_sum = 0;
    ref_setter_contextualised_node.inputLinksId.filter(lid => (0, FunctionOSTyped_1.NodeDisplayed)(data, data.nodes[data.links[lid].idSource]))
        .forEach((idLink) => {
        const tmp = (0, FunctionOSTyped_1.GetLinkValue)(data, idLink).value;
        input_link_sum += tmp !== '' ? tmp : 0;
    });
    const node_value = Math.max(1, Math.max(input_link_sum, output_link_sum));
    // Define vertical scaling functions
    data.user_scale = node_value / 2.0;
    // Contextualized Node size must be 200px
    const v_scale = d3.scaleLinear()
        .range([0, 200])
        .domain([0, node_value]);
    const v_scale_inv = d3.scaleLinear()
        .domain([0, 200])
        .range([0, node_value]);
    // Positionning values
    const v_space = data.v_space;
    // Reset input / ouput links id for each node
    (0, SankeyDrawLayout_1.compute_default_input_outputLinksId)(data.nodes, data.links);
    // Get list of all visible nodes
    //  /!\ the nodes of this list will be the only nodes
    //      that are going to be positionned
    const visible_nodes_ids = Object.values(data.nodes)
        .filter(n => (0, FunctionOSTyped_1.NodeDisplayed)(data, n) && (n.position !== 'relative'))
        .map(n => n.idNode);
    // Compute positionning indexes
    const horizontal_indexes_per_nodes_ids = {};
    const possible_recycling_links_ids = [];
    Object.values(visible_nodes_ids)
        .forEach(node_id => {
        const node = data.nodes[node_id];
        if ((node.inputLinksId.length === 0) &&
            (node.outputLinksId.length > 0)) {
            // get current node horizontal index (eg longest branch length)
            const starting_index = 0;
            (0, FunctionOSTyped_1.computeHorizontalIndex)(node, starting_index, visible_nodes_ids, [], possible_recycling_links_ids, horizontal_indexes_per_nodes_ids, data.links, data.nodes);
        }
        else {
            // Lone node case
            if ((node.inputLinksId.length === 0) &&
                (node.outputLinksId.length === 0)) {
                horizontal_indexes_per_nodes_ids[node_id] = 0;
            }
        }
    });
    // Double check recycling links
    const checked_recycling_links_ids = [];
    Object.values(possible_recycling_links_ids)
        .forEach(link_id => (0, SankeyDrawLayout_1.compute_recycling_horizontal_index)(data.links[link_id], visible_nodes_ids, checked_recycling_links_ids, horizontal_indexes_per_nodes_ids, data.links, data.nodes));
    // Use results from previous index computing
    // TODO : maybe possible to speed up here overall computing with getting
    //        max_horizontal_index and nodes_per_horizontal_indexes from another loop
    let max_horizontal_index = 0;
    const nodes_per_horizontal_indexes = {};
    Object.values(visible_nodes_ids).forEach(node_id => {
        // Previously computed index for given node
        const node_index = horizontal_indexes_per_nodes_ids[node_id];
        // Update reversed dict index-> nodes
        if (!nodes_per_horizontal_indexes[node_index]) {
            nodes_per_horizontal_indexes[node_index] = [];
        }
        nodes_per_horizontal_indexes[node_index].push(data.nodes[node_id]);
        // Update max horizontal index
        if (node_index > max_horizontal_index) {
            max_horizontal_index = node_index;
        }
        // Set recycling links
        Object.values(data.nodes[node_id].outputLinksId)
            .forEach(link_id => {
            // Get id for source and target
            const target_node_id = data.links[link_id].idTarget;
            // Compute only if indexes for source >= index for target
            // which can not be the case if these nodes have been reprocessed
            // by this same function
            if (node_index >= horizontal_indexes_per_nodes_ids[target_node_id]) {
                (0, FunctionOSTyped_1.AssignLinkLocalAttribute)(data.links[link_id], 'recycling', true);
            }
            else {
                (0, FunctionOSTyped_1.AssignLinkLocalAttribute)(data.links[link_id], 'recycling', false);
            }
        });
    });
    // Loop on all index "columns"
    let h_left_margin = h_space;
    let h_right_margin = h_space;
    const height_cumul_per_indexes = [];
    const height_per_nodes_ids = {};
    const node_id_per_hxv_indexes = [];
    let max_height_cumul = 0;
    for (let h_index = 0; h_index <= max_horizontal_index; h_index++) {
        // Pass if no nodes for this index
        if (!nodes_per_horizontal_indexes[h_index]) {
            continue;
        }
        // Loop on nodes from computed horizontal index
        let height_cumul_for_index = 0;
        let max_vertical_index = 0;
        const sortcoef_per_nodes_ids = {};
        const vertical_indexes_per_node_id = {};
        const nodes_ids_per_vertical_index = [];
        nodes_per_horizontal_indexes[h_index]
            .forEach(node => {
            // Node height
            const node_height = (0, SankeyDrawLayout_1.nodeHeight)(node, data, display_nodes, v_scale_inv, v_scale, FunctionOSTyped_1.GetLinkValue);
            // Coef to verticaly sort nodes - highest coef is upper
            // - Empirique : prend en considération taille du neoud et taille du noeud normalisée
            const node_sortcoef = node_height * (0.8 + 0.2 / (node.outputLinksId.length + node.inputLinksId.length));
            // Verticaly sort nodes accordingly to their height
            height_per_nodes_ids[node.idNode] = node_height;
            sortcoef_per_nodes_ids[node.idNode] = node_sortcoef;
            vertical_indexes_per_node_id[node.idNode] = max_vertical_index;
            nodes_ids_per_vertical_index.push(node.idNode);
            if (max_vertical_index > 0) {
                // Bubble sort algo
                for (let v_index = max_vertical_index; v_index > 0; v_index--) {
                    // Prev node infos
                    const prev_v_index = v_index - 1;
                    const prev_node_id = nodes_ids_per_vertical_index[prev_v_index];
                    const prev_node_sortcoef = sortcoef_per_nodes_ids[prev_node_id];
                    if (prev_node_sortcoef < node_sortcoef) {
                        // Update referencing for bubble node
                        vertical_indexes_per_node_id[node.idNode] = prev_v_index;
                        nodes_ids_per_vertical_index[prev_v_index] = node.idNode;
                        // Update referencing for prev node
                        vertical_indexes_per_node_id[prev_node_id] = v_index;
                        nodes_ids_per_vertical_index[v_index] = prev_node_id;
                    }
                    else {
                        break;
                    }
                }
            }
            max_vertical_index += 1;
            // Compute cumulative height for given index
            height_cumul_for_index += node_height;
            // Compute left horizontal margin
            if (h_index === 0) {
                const node_label_width = data.style_node[node.style].label_box_width;
                const needed_margin = data.grid_square_size + node_label_width;
                if (needed_margin > h_left_margin) {
                    h_left_margin = needed_margin;
                }
            }
            // Compute right horizontal margin
            // if (h_index == (max_horizontal_index - cumul_shifting_value)) {
            if (h_index === max_horizontal_index) {
                const node_label_width = data.style_node[node.style].label_box_width;
                const needed_margin = data.grid_square_size + node_label_width;
                if (needed_margin > h_right_margin) {
                    h_right_margin = needed_margin;
                }
            }
            // Place labels accordingly
            // If node is lone, source, sink or in the middle
            if ((node.inputLinksId.length === 0) &&
                (node.outputLinksId.length === 0)) {
                // Node is lone node
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_horiz', 'middle');
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_vert', 'middle');
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_background', false);
            }
            else if (node.inputLinksId.length === 0) {
                // Node is a source : no input link
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_horiz', 'left');
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_vert', 'middle');
            }
            else if (node.outputLinksId.length === 0) {
                // Node is a sink : no output link
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_horiz', 'right');
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_vert', 'middle');
            }
            else {
                // Node is in the middle of the sankey
                // Generally the unitary node
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_horiz', 'middle');
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_vert', 'bottom');
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(node, 'label_background', false);
            }
        });
        // Get horizontal index that need the most of vertical space
        // with vertical spacing between nodes in account
        height_cumul_for_index += (nodes_per_horizontal_indexes[h_index].length - 1) * (v_space);
        if (height_cumul_for_index > max_height_cumul) {
            max_height_cumul = height_cumul_for_index;
        }
        height_cumul_per_indexes.push(height_cumul_for_index);
        // Update global indexing table
        node_id_per_hxv_indexes.push(nodes_ids_per_vertical_index);
    }
    max_horizontal_index = (node_id_per_hxv_indexes.length - 1);
    // Update horizontal and vertical position of nodes
    // compute total height of nodes that belong to the same column,
    // then compute the spaces between them and their positions.
    const v_margin = v_space;
    for (let horizontal_index = 0; horizontal_index <= max_horizontal_index; horizontal_index++) {
        // Pass if no nodes for this horizontal_index
        // TODO : if it is the case -> something was wrong before
        if (!node_id_per_hxv_indexes[horizontal_index]) {
            continue;
        }
        //take into account the width of the previous column
        //We go throught all the node of the previous column and compute their witdth and keep the max width 
        let max_node_w = 0;
        // Since the first column only contians node without inputLink there is no shift to add
        if (horizontal_index > 0) {
            node_id_per_hxv_indexes[horizontal_index - 1]
                .forEach(node_id => {
                const node_face_size = (0, FunctionOSTyped_1.ComputeTotalOffsets)(v_scale_inv, data.nodes[node_id], data, display_nodes, data.links, FunctionOSTyped_1.TestLinkValue, undefined, FunctionOSTyped_1.GetLinkValue);
                const max_face_side_w = Math.max(node_face_size[2], node_face_size[3], (0, FunctionOSTyped_1.ReturnValueNode)(data, data.nodes[node_id], 'node_width'));
                max_node_w = max_node_w < max_face_side_w ? max_face_side_w : max_node_w;
            });
        }
        // Loop on horizontal_index node
        const center_biggest_nodes = (node_id_per_hxv_indexes[horizontal_index].length > 2) && true; // TODO put function arg instead of true
        const h_position_for_index = max_node_w + h_left_margin + horizontal_index * h_space;
        const v_margin_for_index = v_margin + (max_height_cumul - height_cumul_per_indexes[horizontal_index]) / 2;
        let upper_node_height_and_margin = v_margin_for_index;
        if (center_biggest_nodes === true) {
            // From the bottom to the top : plot node every two index
            let last_index = (node_id_per_hxv_indexes[horizontal_index].length - 1);
            for (let index = last_index; index >= 0; index -= 2) {
                const node_id = node_id_per_hxv_indexes[horizontal_index][index];
                // Node position
                data.nodes[node_id].x = h_position_for_index;
                data.nodes[node_id].y = upper_node_height_and_margin;
                // Update upper margin for next node
                const node_height = height_per_nodes_ids[node_id];
                upper_node_height_and_margin += node_height + v_margin;
                // Update last index
                last_index = index;
            }
            // From the top to the bottom : remaining index
            if (last_index === 0)
                last_index = 1;
            else
                last_index = 0;
            for (let index = last_index; index < node_id_per_hxv_indexes[horizontal_index].length; index += 2) {
                const node_id = node_id_per_hxv_indexes[horizontal_index][index];
                // Node position
                data.nodes[node_id].x = h_position_for_index;
                data.nodes[node_id].y = upper_node_height_and_margin;
                // Update upper margin for next node
                const node_height = height_per_nodes_ids[node_id];
                upper_node_height_and_margin += node_height + v_margin;
            }
        }
        else {
            node_id_per_hxv_indexes[horizontal_index]
                .forEach(node_id => {
                // Compute node height and use it to shift the node y position by half his height
                const node_face_size = (0, FunctionOSTyped_1.ComputeTotalOffsets)(v_scale_inv, data.nodes[node_id], data, display_nodes, data.links, FunctionOSTyped_1.TestLinkValue, undefined, FunctionOSTyped_1.GetLinkValue);
                const max_face_side_h = Math.max(node_face_size[0], node_face_size[1], (0, FunctionOSTyped_1.ReturnValueNode)(data, data.nodes[node_id], 'node_height'));
                // Node position
                data.nodes[node_id].x = h_position_for_index;
                data.nodes[node_id].y = upper_node_height_and_margin - v_scale(max_face_side_h / 2);
                // Update upper margin for next node
                const node_height = height_per_nodes_ids[node_id];
                upper_node_height_and_margin += node_height + v_margin;
            });
        }
    }
    data.width = h_left_margin + max_horizontal_index * h_space + h_right_margin;
    // TEST HERE WHY data.height become null
    data.height = v_margin * 2 + max_height_cumul;
    (0, SankeyDrawLayout_1.reorganize_all_input_outputLinksId)(data, data.nodes, data.links);
    return [];
};
exports.compute_auto_unitary_sankey = compute_auto_unitary_sankey;
